'use strict';

import * as dom from './lib/dom';

function copyLink() {
	const linkBtn = document.querySelectorAll('.js-copy-link');
    if (linkBtn.length < 1) { return; }

    dom.forEachEl(linkBtn, (el) => {
        el.addEventListener('click', (e)=>{
            e.preventDefault();
            const btnText = el.querySelector('span');
            let dummy = document.createElement('input')
            const text = window.location.href;
    
            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
            if (btnText) {
                btnText.innerHTML = 'Copiado';
            } else {
                alert('Copiado');
            }
            
        })
    });
    
}

export default function(){
	window.addEventListener('DOMContentLoaded', function() {
        copyLink();
  	});
}
